import React from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import teacherActions from '../../state/teacher/actions'
import cx from 'classnames'

export default function ClassProgressReportType(props) {
  const {isDisabled, isLoading} = props;

  const selectedClassProgressReportType = useSelector(state => state.reports.teacher.classProgressReportType);
  const dispatch = useDispatch();

  const {t} = useTranslation("reports_sidebar");

  const toggleClassProgressReportType = (reportType) => {
    dispatch(teacherActions.setState({classProgressReportType: reportType}));
  }

  const radioClass = cx({
    "reportsRadioButton": true,
    "is-disabled": isDisabled,
    "is-loading": isLoading
  })

  return (
    <div className="reportsSubselection">
      <div className="reportsAdditionalSelectionTitle"> {t("report_type")} </div>
      <div className="reportsRadioButtonSet">
        <div className={radioClass}>
          <input
            id="class-progress_radio_btn"
            type="radio"
            onChange={() => toggleClassProgressReportType(CLASSPROGRESS_REPORT_TYPES.CLASS_PROGRESS)}
            checked={selectedClassProgressReportType === CLASSPROGRESS_REPORT_TYPES.CLASS_PROGRESS}
            disabled={isDisabled} />
          <label htmlFor="class-progress_radio_btn">{t("class_progress")}</label>
          <div className="check"></div>
        </div>
        <div className={radioClass} >
          <input
            id="thread-overview_radio_btn"
            type="radio"
            onChange={() => toggleClassProgressReportType(CLASSPROGRESS_REPORT_TYPES.THREAD_OVERVIEW)}
            checked={selectedClassProgressReportType === CLASSPROGRESS_REPORT_TYPES.THREAD_OVERVIEW}
            disabled={isDisabled} />
          <label htmlFor="thread-overview_radio_btn">{t("thread_overview")}</label>
          <div className="check"></div>
        </div>
      </div>
    </div>
  )
}

export const CLASSPROGRESS_REPORT_TYPES = {
  CLASS_PROGRESS: "classProgress",
  THREAD_OVERVIEW: "threadOverview",
}